import React from 'react';
import { Trash2 } from 'lucide-react';
import { Section, LinkRow } from '../workersetting/settinghelper/SettingsHelpers';

const AccountSection = ({ handleDeleteAccount }) => {
  return (
    <Section title="ACCOUNT">
      <LinkRow icon={<Trash2 size={20} />} iconColor="#dc2626" iconBg="#fef2f2"
        title="Delete Account" subtitle="Permanently remove your account"
        onClick={handleDeleteAccount} danger />
    </Section>
  );
};

export default AccountSection;